import { AES, enc } from 'crypto-js';
import { useEffect, useState } from 'react';
import config from '../config';
import routes from '../routes';
import { baseLocalQueryParam } from '../utils/functions';
import { useAppStore } from './useAppStore';

const secret = config.URL_ENCRYPTION_SECRET;
const isDevEnv = process.env.NODE_ENV !== 'production';
const hashedQueryParamKey = '?mvpPlanData=';

const encryptQueryParameters = (localQueryParam: string) => {
  const encryptedUrl = AES.encrypt(localQueryParam, secret);
  return `${hashedQueryParamKey}${encodeURIComponent(encryptedUrl.toString())}`;
}

const encryptUrl = (encryptedQueryParameter: string) => {
  return `${routes.eligibility.home}${encryptedQueryParameter}`;
}

const decryptUrl = (hashedUrl: string) => {
  const bytesUrl = AES.decrypt(decodeURIComponent(hashedUrl), secret);
  return bytesUrl.toString(enc.Utf8);
}

const useUrlEncryption = () => {
  const { appStoreDispatch, appStore: { planInfo }, } = useAppStore();

  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const updateInfo = (localQueryParam: string, encryptedQueryParam: string) => {
    appStoreDispatch("setAppQueryParam", encryptedQueryParam)
    appStoreDispatch("setPlanInfo", new URLSearchParams(localQueryParam));
  }

  const encryptNewUrl = (localQueryParam: string) => {
    const encryptedParam = encryptQueryParameters(localQueryParam);
    updateInfo(localQueryParam, encryptedParam);
    window.location.href = encryptUrl(encryptedParam);
  }

  const decryptOldUrl = (hashedUrl: string) => {
    try {
      const decryptedLocalParams = decryptUrl(hashedUrl);
      updateInfo(decryptedLocalParams, `${hashedQueryParamKey}${encodeURIComponent(hashedUrl)}`);
    } catch(err) {
      setShowError(true);
    }
  };

  useEffect(() => {
    setIsLoading(true);

    const localQueryParam = window.location.search;

    if (localQueryParam) {
      const params = new URLSearchParams(localQueryParam);
      const hashedUrl = params.get('mvpPlanData');

      if (!hashedUrl) {
        encryptNewUrl(localQueryParam);
      } else {
        const isThankYouPage = window.location.pathname === routes.reviewSelection.thankYou;
        const shouldDecryptUrl = !isThankYouPage || !planInfo;
        
        if (shouldDecryptUrl) {
          decryptOldUrl(hashedUrl);
        }
      }
    } else {
      if (isDevEnv) {
        window.location.href = encryptUrl(baseLocalQueryParam);
      } else {
        setShowError(true);
      }
    }
    
    setIsLoading(false);
  }, []);

  return { showError, isLoading };
}

export default useUrlEncryption